import { DefaultTheme } from 'styled-components';
import { b2bDark, gxDark, gxLight, b2bLight } from '@mews/design-tokens';
import { ComponentsProps, Theme, ThemeVariant } from '@optimus-web/common';

const defaultComponentsProps: ComponentsProps = {
    Autocomplete: { size: 'medium' },
    Button: { size: 'medium' },
    IconButton: { size: 'medium' },
    ListItem: { dense: false },
    Checkbox: { size: 'medium' },
    Select: { size: 'medium' },
    Input: { size: 'medium' },
    Stepper: { size: 'medium' },
    NumberInput: { size: 'medium' },
};

interface CreateTheme {
    themeVariant?: ThemeVariant;
    tokenOverrides?: Partial<Theme>;
    componentsProps?: Partial<ComponentsProps>;
}

export const createTheme = ({ themeVariant, tokenOverrides = {}, componentsProps }: CreateTheme): DefaultTheme => {
    const getThemeVariant = (variant?: ThemeVariant) => {
        switch (variant) {
            case 'b2bLight':
                return b2bLight;
            case 'b2bDark':
                return b2bDark;
            case 'gxLight':
                return gxLight;
            case 'gxDark':
                return gxDark;
            default:
                return b2bLight;
        }
    };
    const tokens = getThemeVariant(themeVariant);
    const finalTokens = {
        ...tokens,
        ...tokenOverrides,
    };

    return {
        settings: {
            rootSize: 16,
            componentsProps: { ...defaultComponentsProps, ...componentsProps },
        },
        tokens: finalTokens,
        themeVariant: themeVariant || 'b2bLight',
    };
};

export const DENSE_B2B_LIGHT_THEME = createTheme({
    themeVariant: 'b2bLight',
});

export const DENSE_B2B_DARK_THEME = createTheme({
    themeVariant: 'b2bDark',
});

export const DENSE_GX_LIGHT_THEME = createTheme({
    themeVariant: 'gxLight',
});

export const DENSE_GX_DARK_THEME = createTheme({
    themeVariant: 'gxDark',
});
